import { Tooltip, Typography } from '@mui/material';
import { formatDateLitteral } from 'helpers/format';
import moment from 'moment';
import React from 'react';

type StartDateCellProps = {
  start_date?: string | Date;
};

const StartDateCell = React.memo((row: StartDateCellProps) => {
  if (!row?.start_date) return null;

  const formattedDate = formatDateLitteral(moment.utc(row?.start_date).format('YYYY/MM/DD'));

  return (
    <Tooltip title={formattedDate}>
      <Typography variant="body2" noWrap>
        {formattedDate}
      </Typography>
    </Tooltip>
  );
});

export default StartDateCell;
